export default "__VITE_ASSET__kaHYIM06__"